import React from 'react';
import { useTheme } from '@mui/material';
import PropTypes from 'prop-types';
import { LegendOrdinal, LegendItem, LegendLabel } from '@visx/legend';
import { scaleOrdinal } from '@visx/scale';
import { formatThousands } from '../../Utils/constants/general';

const GraphsLegend = function GraphsLegend({
  legendData,
  legendColor,
  flexDirection = 'column',
  height = null,
  styles = {},
  scroll = false,
}) {
  const theme = useTheme();
  //creates the legend from 2 arrays of data and colors
  const scaledLegend = scaleOrdinal({
    domain: legendData,
    range: legendColor,
  });

  return (
    <LegendOrdinal scale={scaledLegend} direction="column" itemDirection="row">
      {(legendItems) => {
        return (
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              flexDirection, //provided from the parent to make legend reusable
              gap: '1.5vh',
              height,
              flexGrow: scroll ? 0 : 1,
              overflowY: scroll ? 'auto' : null,
            }}
          >
            {legendItems.map((item, index) => (
              <LegendItem key={item.index}>
                {typeof item.value === 'object' ? (
                  item.value
                ) : (
                  <svg width={15} height={15}>
                    <rect
                      fill={item.value}
                      width={styles?.icon?.width || 15}
                      height={styles?.icon?.height || 15}
                      rx={2}
                      ry={2}
                      style={{ ...(styles?.icon ?? {}) }}
                    />
                  </svg>
                )}
                <LegendLabel align="left" margin="0 0 0 20px">
                  <span
                    title={item.text}
                    style={{
                      fontFamily: 'Roboto',
                      color:
                        typeof item.value === 'object' && index === 0
                          ? theme.palette.greys.darker
                          : theme.palette.greys.secondary,
                      fontSize: '1rem',
                      ...(styles?.label ?? {}),
                    }}
                  >
                    {item.text?.split(':')[0]}:{' '}
                    <strong>
                      <span
                        style={{
                          color: item.value,
                          fontSize: '1.2rem',
                          ...(styles?.value ?? {}),
                        }}
                      >
                        {formatThousands(
                          parseInt(item.text?.split(':')?.[1], 10)
                        )}
                      </span>
                    </strong>
                  </span>
                </LegendLabel>
              </LegendItem>
            ))}
          </div>
        );
      }}
    </LegendOrdinal>
  );
};

GraphsLegend.propTypes = {
  legendData: PropTypes.array.isRequired,
  legendColor: PropTypes.array.isRequired,
  flexDirection: PropTypes.string,
  height: PropTypes.string,
  scroll: PropTypes.bool,
};

export default GraphsLegend;
